<template>
    <div>
        <div>
            <div id="alertbar">{{text}}
                <!-- <span class="mdi mdi-close close-icon" v-on:click="hide()"></span> -->
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        inheritAttrs: true,
        props: {},
        data() {
            return {
                isShowed: false,
                text: '',
            };
        },
        methods: {
            show(value) {
                this.text = value;
                let self = this;
                let alertbar = document.getElementById("alertbar");
                if (alertbar == null) {
                    document.getElementById("app").appendChild(this.$el);
                }
                alertbar = document.getElementById("alertbar");
                if (!alertbar.classList.contains("show")) {
                    alertbar.classList.add("show");
                    setTimeout(function () {
                        self.hide();
                    }, 2800);
                }
            },
            hide() {
                let alertbar = document.getElementById("alertbar");
                if (alertbar != null) {
                    if (alertbar.classList.contains("show")){
                        alertbar.classList.remove("show");
                    }
                }
            },
        },
        beforeMount() {
            this.$nextTick(function () {
            });
        },
        mounted() {
        }
    };
</script>

<style scoped>
    #alertbar {
        visibility: hidden;
        min-width: 250px;
        margin-left: -125px;
        background-color: #F5365C;
        color: #fff;
        text-align: center;
        border-radius: 2px;
        padding: 16px;
        position: fixed;
        z-index: 20;
        left: 50%;
        top: 150px;
        font-size: 17px;
    }

    #alertbar.show {
        visibility: visible;
        -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
        animation: fadein 0.5s, fadeout 0.5s 2.5s;
    }

    .close-icon{
        position: absolute;
        right: 1em;
        cursor: pointer;
        font-size: 1.25em;
    }

    @-webkit-keyframes fadein {
        from {
            top: 120px;
            opacity: 0;
        }
        to {
            top: 150px;
            opacity: 1;
        }
    }

    @keyframes fadein {
        from {
            top: 120px;
            opacity: 0;
        }
        to {
            top: 150px;
            opacity: 1;
        }
    }

    @-webkit-keyframes fadeout {
        from {
            top: 150px;
            opacity: 1;
        }
        to {
            top: 120px;
            opacity: 0;
        }
    }

    @keyframes fadeout {
        from {
            top: 150px;
            opacity: 1;
        }
        to {
            top: 120px;
            opacity: 0;
        }
    }
</style>
